function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStateRedDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.41,
    height: 27.41,
    viewBox: "0 0 27.41 27.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.7,
    cy: 13.7,
    r: 13.7,
    style: {
      fill: "red",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.45,18.2h3s0,3,0,3h-3s0-3,0-3m0-12h3s0,9,0,9h-3s0-9,0-9",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateRedDanger);
export default __webpack_public_path__ + "static/media/state-red-danger.c25a1cc7def50fc3d60ba5d2983c929a.svg";
export { ForwardRef as ReactComponent };